import { render } from "./ScoreboardTrendModal.vue?vue&type=template&id=e44f0abe&scoped=true&ts=true"
import script from "./ScoreboardTrendModal.vue?vue&type=script&lang=ts"
export * from "./ScoreboardTrendModal.vue?vue&type=script&lang=ts"

import "./ScoreboardTrendModal.vue?vue&type=style&index=0&id=e44f0abe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e44f0abe"]])

export default __exports__